import * as React from "react"
const ShopAndSearch = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} {...props}>
    <title>{"Group 27"}</title>
    <g fill="none" fillRule="evenodd" transform="translate(0 1)" stroke={props.stroke}>
      <g stroke={props.stroke}>
        <path d="M15.827 15.861c3.166 0 6.02-1.932 7.232-4.896a8.007 8.007 0 0 0-1.697-8.642 7.753 7.753 0 0 0-8.53-1.719C9.905 1.832 8 4.724 8 7.932c0 4.38 3.505 7.93 7.827 7.93Z" />
        <path strokeLinecap="round" d="M21.417 13.595 26 18" />
      </g>
      <rect width={8} height={0.5} y={2} stroke={props.stroke} rx={0.5} />
      <rect width={8} height={0.5} y={14} stroke={props.stroke} rx={0.5} />
      <rect width={6} height={0.5} y={8} stroke={props.stroke} rx={0.5} />
    </g>
  </svg>
)
export default ShopAndSearch;